module.exports = __webpack_public_path__ + "images/article-2-photo-1.jpg";